import { RowSelectionOptions } from '@ag-grid-community/core';
import { Component } from '@angular/core';
import { Manufacturer, ProductType } from 'app/model/entities/entity-model';
import { AgFns, ISortModel, RowSelectionSingle } from 'app/shared/ag-fns';
import { DbQueryService } from 'app/shared/db-query.service';
import { EntityFinderDialog } from 'app/shared/entity-finder.dialog';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

export interface ProductTypeFinderParams {
  manufacturer?: Manufacturer;
  header?: string;
  rowSelection?: RowSelectionOptions; // default is single
}
 
@Component({
    template: EntityFinderDialog.HTML,
    host: { 'hostID': crypto.randomUUID().toString() },
    standalone: false
})
export class ProductTypeFinderDialogComponent extends EntityFinderDialog<ProductType, ProductTypeFinderParams> {

  constructor(
    ref: DynamicDialogRef,
    config: DynamicDialogConfig<ProductTypeFinderParams>,
    public dbQueryService: DbQueryService,
  ) {
    super(ref, config);

    const rowSelection = this.params.rowSelection ?? RowSelectionSingle;
    const suffix = rowSelection.mode == 'multiRow' ? 's' : '';

    Object.assign(this.config, {
      header: this.config.header ?? `Select Product Type` + suffix,
      width: '800px',
      height: '830px',
    });
  }

  override async initDatasource() {
    let q = this.dbQueryService.createProductTypeFinderQuery(this.params.manufacturer?.id);
    const ds = AgFns.buildDatasource(() => q);
    return ds;
  }
  
  override getColDefsAndSortModel() {
    const colDefs = [
      { headerName: 'Manufacturer', field: 'manufacturer.name',  filter: 'agTextColumnFilter'  },
      { headerName: 'Description', field: 'description', filter: 'agTextColumnFilter' },
      { headerName: 'SKU', field: 'style', filter: 'agTextColumnFilter' },
    ];
    const sortModel = [
      { colId: 'manufacturer.name', sort: 'asc' },
      { colId: 'description', sort: 'asc' },
      { colId: 'style', sort: 'asc' },
      
    ] as ISortModel;
    return [colDefs, sortModel] as const;
  }


}
